import * as React from 'react';
import Fab from '@mui/material/Fab';
import FeedbackIcon from '@mui/icons-material/Feedback';
import { useDispatch } from 'react-redux';
import { showSurvey, setCurrentPage } from './FeedbackSlice';

function FeedbackFab() {
    const dispatch = useDispatch();

    const handleClick = () => {
        dispatch(setCurrentPage(window.location.pathname));
        dispatch(showSurvey());
    };

    return (
        <Fab
            color="secondary"
            size="medium"
            onClick={handleClick}
            className="no-print"
            sx={{
                position: 'fixed',
                bottom: 24,
                left: 24,
                zIndex: 1000,
                backgroundColor: '#FF5722',
                '&:hover': {
                    backgroundColor: '#FF5722',
                    transform: 'scale(1.1)'
                },
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 20px rgba(255, 107, 53, 0.4)',
                display: { xs: 'none', sm: 'flex' } // Hide on mobile to avoid conflict with bottom nav
            }}
        >
            <FeedbackIcon />
        </Fab>
    );
}

export default FeedbackFab;
